import { Component, inject, computed } from '@angular/core';
import { SettingsService } from '@app/services/settings/settings.service';
import { LayoutService } from '@app/services/settings/layout.service';
import { mobileMenuAnimation } from '@app/shared/animations/mobile-menu.animation';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MobileMenuComponent } from '../../shared/mobile-menu/mobile-menu.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { SocialMediaLinksFloatingComponent } from '../../shared/social-media-links/social-media-links-floating/social-media-links-floating.component';
import { NavigationBarComponent } from '../../shared/navigation-bar/component/navigation-bar.component';
@Component({
  selector: 'app-main-layout',
  template: `
    @if (settings(); as settings) {
      <app-navigation-bar
        [showProposals]="canFeatureProposals()"
        [headerData]="settings.header"
        [parsedMenu]="parsedMenu()"></app-navigation-bar>
      @if (showMobileMenu()) {
        <app-mobile-menu
          @mobileMenuAnimation
          [showProposals]="canFeatureProposals()"
          [headerData]="settings.header"
          [parsedMenu]="parsedMenu()"
          (closeMenuEvent)="layout.showMenu(false)">
        </app-mobile-menu>
      }
      <app-social-media-links-floating></app-social-media-links-floating>
      <router-outlet></router-outlet>
      <app-footer [settings]="settings" ngSkipHydration></app-footer>
    }
  `,
  styleUrls: ['./main-layout.component.scss'],
  animations: [mobileMenuAnimation],
  imports: [
    NavigationBarComponent,
    SocialMediaLinksFloatingComponent,
    RouterOutlet,
    FooterComponent,
    MobileMenuComponent,
    MatProgressSpinnerModule,
  ],
})
export class MainLayoutComponent {
  private readonly settingsService = inject(SettingsService);
  private readonly layout = inject(LayoutService);
  headerMenus = this.layout.menuItems;

  readonly settings = this.settingsService.settings;
  readonly headerData = computed(() => this.settings()?.header);
  readonly canFeatureProposals = computed(() => this.settingsService.isProposalDomain());
  readonly showMobileMenu = this.layout.showMobileMenu;

  parsedMenu = computed(() => {
    return this.headerMenus.filter((item, index) => {
      if (item.key === 'blog') {
        return this.settings()?.hasBlog;
      } else if (item.key === 'proposals') {
        return this.settings()?.hasProposal;
      } else {
        return true;
      }
    });
  });
}
